import type { Tables } from "@msuite/utils/types";
import { useFormContext } from "react-hook-form";
import { ProjectSearch } from "@/components/projects";

export function RelatedProject() {
	/** Context */
	const methods = useFormContext<Tables<"projects">>();

	return (
		<ProjectSearch
			defaultProjectId={methods.getValues("relatedProjectId")}
			onChange={(projectId) => {
				methods.setValue("relatedProjectId", projectId);
			}}
			label="projects.fields.related_project"
			data-cy="related-project-search"
		/>
	);
}
